var map = {
	"./boots/overall/green.jpg": "a75f",
	"./gloves/overall/green.jpg": "591c",
	"./jackets/back/green.jpg": "46f7",
	"./jackets/chest/green.jpg": "46f4",
	"./jackets/elbow/green.jpg": "31ab",
	"./jackets/shoulder/green.jpg": "3eca",
	"./pants/hip/green.jpg": "0713",
	"./pants/knee/green.jpg": "e438",
	"./pants/tailbone/green.jpg": "1a83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc32";